import { Component } from '@angular/core';

import { EndorsementBase } from '../../models';

@Component({
    selector: 'app-checkbox-endorsement',
    templateUrl: './checkbox-endorsement.component.html',
    styleUrls: ['./checkbox-endorsement.component.scss'],
    standalone: false
})
export class CheckboxEndorsementComponent extends EndorsementBase {

  get isChecked() {
      return (
        this.endorsementLocation?.statusCode === 'SIGNED'
      );
  }

  get notCheckable() {
    if (this.areAllEndorsementsSigned) {
      return true;
    }

    return this.notCheckableOnDevice;
  }

  get notCheckableOnDevice() {
    if (this.areAllEndorsementsSigned) {
      return true;
    }

    return !this.endorsementLocation?.isSignableOnDevice || this.isEndorsementDisabled;
  }

  get visible() {
    return (
      !this.endorsementLocation?.isSignableInCurrentSession &&
      this.endorsementLocation?.statusCode !== 'SIGNED'
    );
  }

  get shouldDisable() {
    return this.isEndorsementDisabled || this.notCheckable;
  }

  endorsementClicked($event: Event): void {
    $event.preventDefault();

    if (this.notCheckable || this.notCheckableOnDevice) {
      return;
    }

    if (this.endorsementLocation?.statusCode !== 'SIGNED') {
      this.signEndorsement.emit({
        endorsementLocationId: this.endorsementLocation.documentEndorsementLocationId,
        endorsementType: this.endorsementLocation.endorsementTypeCode,
        optional: !this.endorsementLocation.isRequired,
        packageUserGuid: this.endorsementLocation.packageUserGuid,
      });
    } else {
      this.eraseSignedEndorsement.emit({
        endorsementLocationId: this.endorsementLocation.documentEndorsementLocationId,
        endorsementType: this.endorsementLocation.endorsementTypeCode,
        optional: !this.endorsementLocation.isRequired,
        packageUserGuid: this.endorsementLocation.packageUserGuid,
      });
    }
  }
}
